import React from "react";
import util from "../../lib/util.js";
import { FormControl, ControlLabel, Button, Alert } from "react-bootstrap";
import CodeList from "./../shared/codelist.jsx";
import ajax from "./../../lib/ajax.js";

export default class SalarySurvey extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            salarySurvey: {
                requestSalarySurveyID: 0,
                requestID: 0,
                sourceName: '',
                surveyDate: '',
                minSalary: '',
                maxSalary: '',
                notes: '',
                creationDate: '',
                creationOperator: '',
                modifyDate: '',
                modifyOperator: '',
                rowGuid: util.newGuid(),
                updated: true,
                errors: []
            },
            href: 'javascript:void(0)',
            resources: {}
        }

        this.onSalarySurveyChange = this.onSalarySurveyChange.bind(this);
        this.onSourceNameChange = this.onSourceNameChange.bind(this);
        this.onSalaryRangeChange = this.onSalaryRangeChange.bind(this);
        this.onFormControlChange = this.onFormControlChange.bind(this);
        this.onClearClick = this.onClearClick.bind(this);
        this.onRemoveClick = this.onRemoveClick.bind(this);
        this.onLoaded = this.onLoaded.bind(this);
        this.loadResources = this.loadResources.bind(this);
    }

    componentDidMount() {
        let self = this;
        setTimeout(function() {
            self.setState({
                salarySurvey: self.props.data
            });
        }, 5);

        this.loadResources();     
    }

    loadResources() {
        const self = this;

        ajax.vm()
            .get(`request-salary-survey-resources`)
            .then(function (res) {
                self.setState({ resources: res.data });
            })
            .catch(function (err) {
                let data = err.response.data;
                if (data.exceptionMessage && data.exceptionMessage.toLowerCase().indexOf("unauthorize") > -1) {
                    browserHistory.push(context.routeUrl(`home`));
                }
                else
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
            });
    }

    onSalarySurveyChange(values) {
        var salarySurvey = this.state.salarySurvey;

        for (var i = 0; i < values.length; i++) {
            var key = values[i].key;
            var value = values[i].value;
            salarySurvey[key] = value;
        }

        salarySurvey.updated = true;

        this.setState({
            salarySurvey: salarySurvey
        });

        if (this.props.onChange)
            this.props.onChange(salarySurvey);
    }

    onSourceNameChange(value, description, id, propertyValue) {
        var values = [];
        values.push({ key: 'salarySource', value: value });
        this.onSalarySurveyChange(values);

        this.setState({
            href: propertyValue == '' ? 'javascript:void(0)' : propertyValue
        });
    }

    onSalaryRangeChange(event) {
        if (util.isDecimal(event.target.value, 7, 2, true)) {
            this.onFormControlChange(event)
        }
    }

    onFormControlChange(event) {
        var values = [];
        values.push({ key: event.target.name, value: event.target.value });
        this.onSalarySurveyChange(values);
    }

    onClearClick() {
        var values = [];
        values.push({ key: 'salarySource', value: '' });
        values.push({ key: 'minSalary', value: '' });
        values.push({ key: 'maxSalary', value: '' });
        values.push({ key: 'notes', value: '' });
        this.onSalarySurveyChange(values);
    }

    onRemoveClick() {
        if (this.props.onRemove)
            this.props.onRemove(this.state.salarySurvey);
    }

    onLoaded(item) {
        this.setState({
            href: item.propertyValue == '' ? 'javascript:void(0)' : item.propertyValue
        });
    }

    render() {
        var errors = [];
        var errorClass = 'ap-hidden';

        if (this.state.salarySurvey.errors !== null) {
            this.state.salarySurvey.errors.map(function (item, i) {
                if (item.error.length > 0) {
                    errors.push(<li key={item.field}>{item.error}</li>);
                }

                errorClass = '';
            });
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-9">
                        <ControlLabel className="ap-report-control-label">{this.state.resources.source}:</ControlLabel>
                        <div className="row">
                            <div className="col-md-8">
                                <CodeList 
                                    id={this.props.id + "_salarySource_" + this.state.salarySurvey.rowGuid}
                                    value={this.state.salarySurvey.salarySource} 
                                    onChange={this.onSourceNameChange} 
                                    category="SALARY_SOURCE"
                                    allText="Select Source"
                                    readOnly={this.props.readOnly}
                                    showDescriptionAsLink={true}
                                    onLoaded={this.onLoaded} />
                            </div>
                            <div className="col-md-4" style={{ "paddingLeft" : "0px" }}>
                                {
                                    (this.props.readOnly == false && (this.state.salarySurvey.salarySource == null || this.state.salarySurvey.salarySource == '') == false) ?
                                    <a href={this.state.href} target="_blank" >{this.state.resources.visitSite}</a> :
                                    ''
                                }
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className={"ap-button-container " + (this.props.readOnly == true ? 'hidden' : '')}>
                            <Button 
                                id={this.props.id + "clear" + this.state.salarySurvey.rowGuid}
                                className="btn-info pull-right"
                                onClick={this.onClearClick}
                                disabled={this.props.readOnly}>
                                {this.state.resources.clear}
                            </Button>
                            <Button 
                                id={this.props.id + "clear" + this.state.salarySurvey.rowGuid}
                                className="btn-info pull-right"
                                onClick={this.onRemoveClick}
                                disabled={this.props.readOnly}>
                                {this.state.resources.remove}
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div>
                            <ControlLabel className="ap-report-control-label">{this.state.resources.salaryRange}:</ControlLabel>
                        </div>
                        {
                            this.props.readOnly == false ?
                                <div className="salary-range">
                                    <span className="salary-range minimum">
                                        <FormControl 
                                            id={this.props.id + "minSalary" + this.state.salarySurvey.rowGuid}
                                            name="minSalary"
                                            type="text" 
                                            value={this.state.salarySurvey.minSalary}
                                            onChange={this.onSalaryRangeChange}
                                            className={this.state.salarySurvey.errors.filter(x => x.field == 'minSalary').length > 0 ? 'ap-report-control-error' : ''}
                                            readOnly={this.props.readOnly}
                                            maxLength="10">
                                        </FormControl>
                                    </span>
                                    <span className="salary-range arrow">
                                        <i className="glyphicon glyphicon-arrow-right"></i>
                                    </span>
                                    <span className="salary-range maximum">
                                        <FormControl 
                                            id={this.props.id + "maxSalary" + this.state.salarySurvey.rowGuid}
                                            name="maxSalary"
                                            type="text" 
                                            value={this.state.salarySurvey.maxSalary}
                                            onChange={this.onSalaryRangeChange}
                                            className={this.state.salarySurvey.errors.filter(x => x.field == 'maxSalary').length > 0 ? 'ap-report-control-error' : ''}
                                            readOnly={this.props.readOnly}
                                            maxLength="10">
                                        </FormControl>
                                    </span>
                                </div> : 
                                <div>
                                    <ControlLabel className="ap-report-control-label ap-black-color">
                                        {
                                            (this.state.salarySurvey.minSalary != null ? this.state.salarySurvey.minSalary : '') +
                                            ' - ' +
                                            (this.state.salarySurvey.maxSalary != null ? this.state.salarySurvey.maxSalary : '')
                                        }
                                    </ControlLabel>
                                </div>

                        }
                        
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ControlLabel className="ap-report-control-label">{this.state.resources.additionalSalaryInformation}:</ControlLabel>
                        {
                            this.props.readOnly == false ?
                                <FormControl 
                                    id={this.props.id + "notes" + this.state.salarySurvey.rowGuid}
                                    name="notes"
                                    componentClass="textarea"
                                    rows="5"
                                    value={this.state.salarySurvey.notes}
                                    onChange={this.onFormControlChange}
                                    readOnly={this.props.readOnly}>
                                </FormControl> :
                                <div><ControlLabel className="ap-report-control-label ap-black-color">{this.state.salarySurvey.notes}</ControlLabel></div>
                        }
                        
                    </div>
                </div>
                <div className={"row " + errorClass}>
                    <div className="col-md-12 col-lg-12">
                        <Alert bsStyle="danger">
                            <ul>
                                {errors}
                            </ul>
                        </Alert>
                    </div>
                </div>
            </div>
        );
    }
}